import React from 'react';

import { FormControlLabel, Checkbox, CheckboxProps, Typography, SxProps } from '@mui/material';

import { camelCaseToUserText } from '@dw/utils';

import { useFormContext } from './Form.Context';
import { Theme } from '@emotion/react';

interface IFormCheckboxInputProps<T> extends Omit<CheckboxProps, 'name' | 'disabled' | 'checked' | 'onChange'> {
    label?: string;
    name: keyof T;
    disabled?: boolean;
    labelSx?: SxProps<Theme>;
}
export function FormCheckboxInput<T>(props: IFormCheckboxInputProps<T>) {
    const {
        label,
        name,
        disabled,
        labelSx,
        ...baseInputProps
    } = props;

    const {
        formData,
        handleFormChange,
        disabled: formDisabled,
        formErrors,
        customFormErrors,
        submitAttempted
    } = useFormContext<T>();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.checked;
        handleFormChange(name, newValue);
    };

    return (
      <FormControlLabel
        label={<Typography variant='body2'>{label ?? camelCaseToUserText(String(name))}</Typography>}
        sx={{
          marginRight: '0px',
          color: submitAttempted && (formErrors[name] || !!customFormErrors[name]) ? 'var(--color-error)' : disabled || formDisabled ? 'var(--color-text-disabled)' : '',
          ...labelSx
        }}
        disabled={disabled || formDisabled}
        control={
          <Checkbox
            {...baseInputProps}
            onChange={handleInputChange}
            checked={(formData[name] as boolean) ?? false}
            disabled={disabled || formDisabled}
            color={submitAttempted && (formErrors[name] || !!customFormErrors[name]) ? 'error' : baseInputProps.color}
            name={String(name)} />
        }
      />
    )
};